// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"style_tabsContainer__1b2e1","buttonContainer":"style_buttonContainer__149tS","selected":"style_selected__1R5Ox","tabsContent":"style_tabsContent__3uJCy"};